/**
 * @param {"Fixed" | "ARM" | "Variable" | "Other"} loanTypeToCheck
 * @returns {"Fixed" | "ARM"}
 */
const formatLoanType = (loanTypeToCheck) => {
	if (loanTypeToCheck === undefined || loanTypeToCheck === null)
		return 'Fixed';

	return loanTypeToCheck.toLowerCase() === 'fixed' ? 'Fixed' : 'ARM';
};

export default formatLoanType;
